import { SurveyTemplate } from '@dreryk/egabinet-survey-frontend-api';

import { assertUnreachable } from '@dreryk/react-common';

import { PreInterviewTemplateStatus } from './status/SurveyPreInterviewTemplateStatus';
import { SurveyPreInterviewTemplateFormBean } from './SurveyPreInterviewTemplateForm.types';

export const formInitializer = (surveyTemplate: SurveyTemplate): SurveyPreInterviewTemplateFormBean => ({
   questions: surveyTemplate.questions.map((question) => ({
      content: question.content,
   })),
});

type SurveyPreInterviewTemplateFormButtonsForTemplateStatusVisitor = <ACCEPT>(status: {
   visitPublished: () => ACCEPT;
   visitNotPublished: () => ACCEPT;
   visitEdit: () => ACCEPT;
}) => ACCEPT;

export const surveyPreInterviewTemplateFormButtonsForTemplateStatusVisitor = (
   preInterviewTemplateStatus: PreInterviewTemplateStatus
): SurveyPreInterviewTemplateFormButtonsForTemplateStatusVisitor => (visitor) => {
   switch (preInterviewTemplateStatus) {
      case 'PUBLISHED':
         return visitor.visitPublished();
      case 'NOT_PUBLISHED':
         return visitor.visitNotPublished();
      case 'EDIT':
         return visitor.visitEdit();
      default:
         return assertUnreachable(preInterviewTemplateStatus);
   }
};

export const getInitialPreInterviewStatus = (publicationDate: Date | undefined): PreInterviewTemplateStatus => {
   return publicationDate ? 'PUBLISHED' : 'NOT_PUBLISHED';
};

export const isEditMode = (preInterviewTemplateStatus: PreInterviewTemplateStatus): boolean => {
   return preInterviewTemplateStatus === 'EDIT';
};
